import React from 'react'

/*
 * Devin's Figma icons for the "Share" and "Edit Agent" actions. Used by
 * AgentRowKebab (slice 1's list-page kebab) AND by the detail-page header
 * so both surfaces render identical glyphs. Stroke follows `currentColor`
 * so callers control the color via CSS (kebab: fg-quaternary-400; danger
 * variants: error-600).
 */

export interface ActionIconProps {
  size?: number
}

export const ShareIcon: React.FC<ActionIconProps> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M5.83333 6.66667L10 2.5L14.1667 6.66667M10 2.5V12.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EditIcon: React.FC<ActionIconProps> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M15 8.33326L11.6667 4.99993M2.08331 17.9166L4.90362 17.6032C5.24819 17.5649 5.42048 17.5458 5.58152 17.4937C5.72439 17.4474 5.86035 17.3821 5.98572 17.2994C6.12702 17.2062 6.2496 17.0836 6.49475 16.8385L17.5 5.83326C18.4205 4.91279 18.4205 3.4204 17.5 2.49993C16.5795 1.57945 15.0871 1.57945 14.1667 2.49992L3.16142 13.5052C2.91627 13.7503 2.79369 13.8729 2.70051 14.0142C2.61784 14.1396 2.55249 14.2755 2.50624 14.4184C2.45411 14.5794 2.43497 14.7517 2.39668 15.0963L2.08331 17.9166Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
